/*eslint-disable*/
import React from 'react';
// react components for routing our app without refresh
import { Redirect, withRouter } from 'react-router-dom';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { PersonAdd, Dashboard } from '@material-ui/icons';

// core components
import Button from 'components/CustomButtons/Button.jsx';
import withUser from '../HOC/HOCwithUser.jsx';
import headerLinksStyle from 'assets/jss/material-kit-react/components/headerLinksStyle.jsx';
import { CircularProgress, Select, MenuItem } from '@material-ui/core';
import { getCookies } from '../../utils/getToken';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';

class MainPageLinks extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            signupRedirect: false,
            dashboardRedirect: false,
            language: 'en'
        };
    }
    handleChangeLanguage = event => {
        this.setState({
            [event.target.name]: event.target.value,
            language: event.target.value
        });
        this.props.changeLanguage(event.target.value);
    };
    renderCmsDetail = slug => {
        this.props.history.push(`/page/${slug}`);
    };
    renderContactUs = () => {
        this.props.history.push(`/contact-us`);
    };

    render() {
        const { classes, userData, cmsLinks } = this.props;
        const { dashboardRedirect } = this.state;

        return (
            <List className={classes.list}>
                {this.props.cmsLinks.length > 0 &&
                    this.props.cmsLinks.map((link, index) => {
                        return (
                            <ListItem
                                className={classes.listItem}
                                key={index}
                                style={{ color: '#ffffff' }}
                            >
                                <Button
                                    target="_blank"
                                    color="transparent"
                                    className={classes.navLink}
                                    onClick={() =>
                                        this.renderCmsDetail(link.slug)
                                    }
                                >
                                    {this.state.language == 'en' && (
                                        <FormattedMessage
                                            id={link.title}
                                            defaultMessage={link.title}
                                        />
                                    )}
                                    {this.state.language == 'ar' && (
                                        <FormattedMessage
                                            id={link.titleArabic}
                                            defaultMessage={link.titleArabic}
                                        />
                                    )}
                                </Button>
                            </ListItem>
                        );
                    })}

                <ListItem
                    className={classes.listItem}
                    style={{ color: '#ffffff' }}
                >
                    <Button
                        target="_blank"
                        color="transparent"
                        className={classes.navLink}
                        onClick={() => this.renderContactUs()}
                    >
                        <FormattedMessage
                            id="Contact Us"
                            defaultMessage="Contact Us"
                        />
                    </Button>
                </ListItem>
            </List>
        );
    }
}

const mapStateToProps = ({ auth, settings }) => {
    return {
        userData: auth.userData,
        cmsLinks: settings.cmsLinks
    };
};

const composedComponent = compose(
    withStyles(headerLinksStyle),
    connect(
        mapStateToProps,
        null
    )
);
export default composedComponent(withRouter(withUser(MainPageLinks)));



// WEBPACK FOOTER //
// ./src/components/Header/MainLeftLinks.js